<template>
  <!-- 顶部操作栏 -->
  <div class="top-btn-bar">
    <el-button type="primary" @click="openAddRoot">新增顶级园区</el-button>
    <el-button @click="refreshTree">刷新区域树</el-button>
    <el-button type="warning" @click="exportArea">导出全部区域台账</el-button>
  </div>

  <div class="main-row">
    <!-- 左侧树形区域 -->
    <div class="tree-col">
      <div class="tree-search">
        <el-input
          v-model="treeKeyword"
          placeholder="搜索区域名称"
          clearable
          @input="filterTree"
        />
      </div>
      <el-tree
        ref="treeRef"
        :data="areaTree"
        :filter-node-method="filterNode"
        draggable
        node-key="id"
        :default-expanded-keys="expandKeys"
        @node-contextmenu="handleRightMenu"
        @node-click="selectNode"
        class="dark-tree"
      >
        <template #default="{ node, data }">
          <span class="tree-label">
            <span :class="data.status === 1 ? 'tag-on' : 'tag-off'"></span>
            {{ data.areaName }}
            <span class="tree-type">[{{ getAreaType(data.type) }}]</span>
          </span>
        </template>
      </el-tree>

      <!-- 右键菜单核心修复：移除trigger、v-show不销毁组件、异步控制显隐 -->
      <div v-show="menuVisible" class="ctxmenu-wrap" :style="menuStyle">
        <el-dropdown
          :visible="menuVisible"
          @visible-change="handleMenuVisibleChange"
        >
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="openAddChild"
                >新增子区域</el-dropdown-item
              >
              <el-dropdown-item @click="openEdit">编辑区域</el-dropdown-item>
              <el-dropdown-item
                v-if="currNodeData?.status === 1"
                @click="disableArea"
                >停用区域</el-dropdown-item
              >
              <el-dropdown-item
                v-if="currNodeData?.status === 0"
                @click="enableArea"
                >启用区域</el-dropdown-item
              >
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>

    <!-- 右侧主内容 -->
    <div class="content-col">
      <div class="info-card" v-if="currNodeData">
        <div class="card-title">
          区域基础信息 <el-button type="primary" size="small"> 保存</el-button>
        </div>
        <el-form :model="currNodeData" label-width="140px" class="info-form">
          <el-row :gutter="20">
            <el-col span="12">
              <el-form-item label="区域编号">
                <el-input v-model="currNodeData.areaCode" />
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="区域名称">
                <el-input v-model="currNodeData.areaName" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col span="12">
              <el-form-item label="区域层级">
                <el-input :value="getLevelText(currNodeData.level)" />
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="区域类型">
                <el-input :value="getAreaType(currNodeData.type)" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col span="12">
              <el-form-item label="管控责任人">
                <el-input v-model="currNodeData.dutyUser" />
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item label="联系电话">
                <el-input v-model="currNodeData.phone" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="地理坐标(X,Y)">
            <el-input v-model="currNodeData.coord" />
          </el-form-item>
          <el-form-item label="区域状态">
            <el-tag :type="currNodeData.status === 1 ? 'success' : 'danger'">
              {{ currNodeData.status === 1 ? "正常启用" : "已停用" }}
            </el-tag>
          </el-form-item>
          <el-form-item label="备注说明">
            <el-input v-model="currNodeData.remark" type="textarea" />
          </el-form-item>
        </el-form>
      </div>
      <div class="empty-tip" v-else>请左侧选择区域节点查看详情</div>

      <div class="table-card" v-if="currNodeData">
        <div class="card-title">当前区域下属监测设备</div>
        <el-table :data="deviceList" border height="290px" class="data-table">
          <el-table-column label="设备编号" prop="equipCode" width="120px" />
          <el-table-column
            label="设备名称"
            prop="equipName"
            min-width="140px"
          />
          <el-table-column label="设备类型" prop="equipTypeTxt" width="110px" />
          <el-table-column label="监测介质" prop="gasType" width="100px" />
          <el-table-column label="运行状态" prop="runStatus" width="100px">
            <template #default="scope">
              <el-tag
                :type="scope.row.runStatus === 'normal' ? 'success' : 'danger'"
              >
                {{ scope.row.runStatus === "normal" ? "在线" : "离线" }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>

  <!-- 新增/编辑弹窗 -->
  <el-dialog
    v-model="dialogVisible"
    title="区域信息编辑"
    width="760px"
    class="dark-dialog"
  >
    <el-form :model="form" label-width="140px">
      <el-form-item label="父级区域">
        <el-tree-select
          v-model="form.parentId"
          :data="treeAllData"
          placeholder="顶级园区不选"
          :props="{ label: 'areaName', children: 'children' }"
        />
      </el-form-item>
      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="区域编号">
            <el-input v-model="form.areaCode" :="!!form.id" />
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="区域名称">
            <el-input v-model="form.areaName" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="区域类型">
            <el-select v-model="form.type">
              <el-option label="产业园区" value="park" />
              <el-option label="生产车间" value="workshop" />
              <el-option label="反应装置" value="device" />
              <el-option label="废气排放口" value="outlet" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="管控责任人">
            <el-input v-model="form.dutyUser" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col span="12">
          <el-form-item label="联系电话">
            <el-input v-model="form.phone" />
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item label="地理坐标">
            <el-input v-model="form.coord" placeholder="X, Y" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="启用状态">
        <el-switch
          v-model="form.status"
          active-text="启用"
          inactive-text="停用"
        />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" rows="3" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveArea">保存区域</el-button>
    </template>
  </el-dialog>
</template>
<script setup lang="js">
import { ref, reactive, nextTick, onBeforeUnmount , onMounted } from 'vue'
import { ElMessage } from 'element-plus'
onMounted(() => {
  selectNode(areaTree.value[0])
})
const expandKeys = ref(['P001'])
// 树搜索
const treeKeyword = ref('')
const treeRef = ref(null)

// 树形基础数据
const areaTree = ref([
  {
    id: 'P001', parentId: '', areaCode: 'P001', areaName: '精细化工产业园',
    type: 'park', level: 1, status: 1, dutyUser: '园区总管', phone: '1380000111', coord: '116.32,38.15', remark: '主生产园区',
    children: [
      {
        id: 'W001', parentId: 'P001', areaCode: 'W001', areaName: '一生产车间',
        type: 'workshop', level: 2, status: 1, dutyUser: '张车间', phone: '1380000222', coord: '116.33,38.16', remark: '苯系物生产工段',
        children: [
          {
            id: 'D001', parentId: 'W001', areaCode: 'D001', areaName: '4#装置装置',
            type: 'device', level: 3, status: 1, dutyUser: '李运维', phone: '1380000333', coord: '116.335,38.162', remark: '甲烷监测重点装置',
            children: [
              { id: 'O001', parentId: 'D001', areaCode: 'O001', areaName: '一号废气排放口', type: 'outlet', level: 4, status: 1, dutyUser: '李运维', phone: '1380000333', coord: '116.336,38.163', remark: 'VOC在线监测点', children: [] }
            ]
          }
        ]
      },
      {
        id: 'W002', parentId: 'P001', areaCode: 'W002', areaName: '储罐区',
        type: 'workshop', level: 2, status: 0, dutyUser: '王主管', phone: '1380000444', coord: '116.31,38.14', remark: '检修临时停用', children: []
      }
    ]
  }
])
const treeAllData = ref(JSON.parse(JSON.stringify(areaTree.value)))

// 右键菜单状态
const currNodeData = ref(null)
const menuVisible = ref(false)
const menuStyle = reactive({ left: '0px', top: '0px' })

// 弹窗
const dialogVisible = ref(false)
const form = reactive({
  id: '', parentId: '', areaCode: '', areaName: '', type: 'workshop',
  dutyUser: '', phone: '', coord: '', status: true, remark: ''
})

// 设备列表
const deviceList = ref([])

// 树过滤方法
const filterNode = (value, data) => {
  if (!value) return true
  return data.areaName.includes(value)
}
const filterTree = () => treeRef.value?.filter(treeKeyword.value)

// ========== 右键菜单核心修复逻辑 ==========
// 监听下拉组件显隐，阻断同步循环
const handleMenuVisibleChange = (val) => {
  nextTick(() => {
    menuVisible.value = val
  })
}

// 右键触发菜单：阻止原生右键、异步更新状态
const handleRightMenu = (e, data) => {
  e.preventDefault()
  // 先关闭旧菜单，避免重叠渲染
  menuVisible.value = false
  currNodeData.value = data
  menuStyle.left = e.pageX + 'px'
  menuStyle.top = e.pageY + 'px'
  // 异步打开菜单，跳出当前渲染周期，彻底解决递归更新
  nextTick(() => {
    menuVisible.value = true
  })
}

// 点击树节点加载设备
const selectNode = (data) => {
  console.log(data)
  currNodeData.value = data
  loadDevice(data.id)
}

// 加载设备数据（修复字符串无引号语法错误）
const loadDevice = () => {
  deviceList.value = [
    { equipCode: 'GDS-001', equipName: '4#装置甲烷探测器', equipTypeTxt: 'GDS气体', gasType: '甲烷', runStatus: 'normal' },
    { equipCode: 'VOC-001', equipName: '排放口VOC监测仪', equipTypeTxt: 'VOC设备', gasType: '非甲烷总烃', runStatus: 'normal' },
    { equipCode: 'LT-002', equipName: '储罐液位仪', equipTypeTxt: '液位设备', gasType: '无', runStatus: 'fault' }
  ]
}

// 文本转换工具函数
const getAreaType = (t) => {
  const map = { park: '产业园', workshop: '车间', device: '反应装置', outlet: '排放口' }
  return map[t] || t
}
const getLevelText = (l) => {
  const map = { 1: '一级-园区', 2: '二级-车间', 3: '三级-装置', 4: '四级-排放口' }
  return map[l]
}

// 弹窗操作
const openAddRoot = () => {
  dialogVisible.value = true
  Object.assign(form, { id: '', parentId: '', areaCode: '', areaName: '', type: 'park', dutyUser: '', phone: '', coord: '', status: true, remark: '' })
}
const openAddChild = () => {
  menuVisible.value = false
  dialogVisible.value = true
  Object.assign(form, { id: '', parentId: currNodeData.value.id, areaCode: '', areaName: '', type: 'workshop', dutyUser: '', phone: '', coord: '', status: true, remark: '' })
}
const openEdit = () => {
  menuVisible.value = false
  dialogVisible.value = true
  Object.assign(form, currNodeData.value)
  form.status = currNodeData.value.status === 1
}

// 启用/停用区域
const disableArea = () => {
  menuVisible.value = false
  currNodeData.value.status = 0
  ElMessage.success('该区域已停用，下属设备不再推送告警')
}
const enableArea = () => {
  menuVisible.value = false
  currNodeData.value.status = 1
  ElMessage.success('区域已恢复启用')
}

// 保存表单
const saveArea = () => {
  form.status = form.status ? 1 : 0
  ElMessage.success(form.id ? '区域修改成功' : '新增区域完成')
  dialogVisible.value = false
  refreshTree()
}

// 刷新树、导出
const refreshTree = () => ElMessage.info('区域树已刷新')
const exportArea = () => ElMessage.success('全部区域台账导出Excel完成')

// 组件销毁时清空菜单状态，避免残留vnode
onBeforeUnmount(() => {
  menuVisible.value = false
  currNodeData.value = null
})
</script>
<style scoped>
.top-btn-bar {
  margin-bottom: 16px;
  display: flex;
  gap: 12px;
}
.main-row {
  display: flex;
  gap: 16px;
  height: calc(100% - 32px);
}
.tree-col {
  width: 320px;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 14px;
  display: flex;
  flex-direction: column;
  position: relative;
}
/* 右键菜单容器绝对定位 */
.ctxmenu-wrap {
  position: absolute;
  z-index: 9999;
}
.tree-search {
  margin-bottom: 12px;
}
.dark-tree {
  flex: 1;
  overflow-y: auto;
}
.dark-tree :deep(.el-tree) {
  background: transparent;
  color: var(--text-sub);
}
.dark-tree :deep(.el-tree-node__content:hover) {
  background: rgba(64, 158, 255, 0.08);
}
.tree-label {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tag-on {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--green);
  box-shadow: 0 0 4px var(--green);
}
.tag-off {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--red);
  box-shadow: 0 0 4px var(--red);
}
.tree-type {
  font-size: 12px;
  color: #7d92b8;
}
.content-col {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 0;
}
.info-card,
.table-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 16px;
}
.empty-tip {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #7d92b8;
  font-size: 14px;
}
.card-title {
  font-size: 16px;
  margin-bottom: 14px;
  color: #d0f8ff;
  border-left: 3px solid var(--blue);
  padding-left: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-form :deep(.el-form-item label) {
  color: var(--text-sub);
}
</style>
